import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";
import { StoryChapter, StoryChapterList, StoryChapterPaginationFilterRequest, UpsertStoryChapter } from '@/models/story-chapter.model';

export const getPagedStoryChapters = async (input: StoryChapterPaginationFilterRequest): Promise<PagedResponseModel<StoryChapterList>> => {
  return await getReq(createUrl("a/Story/Chapter/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getStoryChaptersLookup = async (input?: string, page?: number, storyId?: number): Promise<PaginatedSelectModel> => {
  const model: StoryChapterPaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false,
    storyId: storyId
  };
  return await getPagedStoryChapters(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getStoryChapter = async (id: number): Promise<BaseResponseModel<StoryChapter>> => {
  return await getReq(createUrl(`a/Story/Chapter/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertStoryChapter = async (input: UpsertStoryChapter): Promise<BaseResponseModel<StoryChapter>> => {
  return await postReq(createUrl("a/Story/Chapter/Upsert"),
    input
  ).then((res: any) => res.data);
};
